import { mods } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled, { css } from 'styled-components';

export const StyledTable = styled.table`
    width: 100%;
    margin-top: 20px;
`;

export const StyledCell = styled.td<
    StyledMods<{ textAlignRight?: boolean; width?: number; minWidth?: number; additionalPaddingLeft?: boolean }>
>`
    padding: 6px 5px 0; // similar to pages/requestList/components/lineItemsSection/lineItemsTable.scss

    ${mods('textAlignRight', true)`
        text-align: right;
    `};

    ${mods('additionalPaddingLeft', true)`
        padding-left: 12px;
    `};

    ${mods('width')(
        (value) => css`
            width: ${value}px;
        `
    )}

    ${mods('minWidth')(
        (value) => css`
            min-width: ${value}px;
        `
    )}
`;
